// @core/api/endpoints/workflow/export_pipeline_yaml.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ExportPipelineYAMLResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Export pipeline as YAML
 * Exports a pipeline version (nodes, connections, config) as a portable YAML document.
 */
export async function ExportPipelineYAML(
  version_id: string,
  options?: RequestOptions
): Promise<ExportPipelineYAMLResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/versions/:version_id/export`;
  requestPath = requestPath.replace(':version_id', encodeURIComponent(version_id));
  const requestOptions = options;
  return client.get<ExportPipelineYAMLResponse>(requestPath, { ...requestOptions });
}
